/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description entity settings constants
 */

// entity settings categories
const ENTITY_SETTINGS_CATEGORIES: Record<'worklist' | 'claim', EntitySettings.IEntityCategory> = {
	worklist: 'worklist_claim',
	claim: 'entity_claim',
};

// fields map
const FIELDS_MAP: Record<'textField' | 'selectField', string> = {
	textField: 'TextField',
	selectField: 'SelectField',
};

// activity type post categories
const ACTIVITY_TYPE_POST_CATEGORIES: Record<'user', EntitySettings.IActivityTypePostCategory> = {
	user: 'user',
};

// write off reason categories
const WRITE_OFF_REASON_CATEGORIES: Record<'system' | 'user', EntitySettings.IWriteOffReasonCategory> = {
	system: 'system',
	user: 'user',
};

export { ENTITY_SETTINGS_CATEGORIES, FIELDS_MAP, ACTIVITY_TYPE_POST_CATEGORIES, WRITE_OFF_REASON_CATEGORIES };
